import DictionaryForm from './DictionaryForm';

export default DictionaryForm;
